<template>
  <div class="org-chart">
    <p class="org-chart-title">
      <span class="h3">{{$t('zu_zhi_jia_gou')}}</span>
      <span class="info">({{$t('dian_ji_zu_zhi_jia_gou_cha_kan_geng_duo_xin_xi')}})</span>
    </p>
    <div v-for="(group, index) in groups">
      <org-chart
        class="department-org-chart"
        :data="group"
        :horizontal="horizontal"
        :collapsable="collapsable"
        :label-class-name="labelClass"
        :render-content="renderContent"
        :key="index"
        @on-expand="onExpand"
        @on-node-click="onNodeClick">
        >
      </org-chart>
    </div>

    <slider :visible.sync="memberVisible"
            :width="'40%'">
      <department ref="departmentInfo" :newDepartment="loadGroups"></department>
    </slider>
  </div>

</template>

<script>
  import OrgChart from '@/components/OrgChart'
  import Slider from '@/components/Slider'
  import Department from './department'
  import {groupList} from '@/api/delivery/organization/group'

  export default {
    name: '',
    components: {
      OrgChart,
      Slider,
      Department
    },
    mounted: function () {
      this.loadGroups()
    },
    data: function () {
      return {
        horizontal: true,
        collapsable: true,
        memberVisible: false,
        groups: {}
      }
    },
    methods: {
      renderContent(h, data) {
        return data.label;
      },
      onExpand(data) {
        if ("expand" in data) {
          data.expand = !data.expand;
          if (!data.expand && data.children) {
//                        this.collapse(data.children);
          }
        } else {
          this.$set(data, "expand", true);
        }
      },
      onNodeClick(e, data) {
        this.$refs.departmentInfo.setGroup({name: data.label, uuid: data.uuid})
        this.memberVisible = true

      },
      loadGroups() {
        groupList().then(res => {
          this.groups = res.data || []
        })
      },
      labelClass(node) {
        switch (node.level) {
          case 0:
            return 'first';
          case 1:
            return 'second';
          case 2:
            return 'three';
          default:
            return 'other';
        }
      },
      insertNewDepartment() {
        this.loadGroups()
      }
    },
  }
</script>

<style lang="scss">
  .org-chart {
    padding: $padding $t-padding;

    .org-chart-title {
      height: $_header_sec_height;
      line-height: 1;

      .info {
        font-size: .6rem;
      }
    }

    .first, .second, .three, .other {
      font-size: .6rem;
      font-weight: $w1;
      color: $f_sec_color;
      cursor: pointer;
      border-radius: .2rem;
    }

    .first:hover, .second:hover, .three:hover, .other:hover {
      background-color: $btn_color;
      color: $f_th_color;
      border: .1rem solid $btn_color;
    }

    .first {
      border: .1rem solid $f_color;
    }

    .second {
      border: .1rem solid $btn_color;
    }

    .three {
      border: .1rem solid $btn_sec_color;
    }

    .other {
      border: .1rem solid $f_sec_color;
    }
  }
</style>
